export enum MediaSharingTypes {
  fb = 'fb',
  whatsapp = 'whatsapp',
  twitter = 'twitter',
  linkedin = 'linkedin',
  reddit = 'reddit',
  email = 'email',
}
